import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { isStaff } from "./access";

// Display gate only; every Admin request is checked again by the server.
const AdminRoute = () => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  return isStaff(user) ? <Outlet /> : <Navigate to="/home" />;
};

export default AdminRoute;
